import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { IUseSearchViewModel } from "../../../../home-tutoring/request-flow/old/store/types";
import { formatToString } from "../../../pages/client/request-flow/Pricing/new";

export type SplitBreakdownProps = {
  handleClosingModal: () => void;
  getRequestData: () => Promise<IUseSearchViewModel["rawData"]>;
};
export const SplitBreakdown = ({
  handleClosingModal,
  getRequestData,
}: SplitBreakdownProps) => {
  const [requestLoading, setRequestLoading] = useState(true);
  const [teacherOption, setTeacherOption] = useState("");
  const [splitRequests, setSplitRequests] = useState<any[]>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    (async () => {
      setError("");
      try {
        const data = await getRequestData();
        if (mounted) {
          setTeacherOption(data.requestData.pricingInfo.teacherOption);
          setSplitRequests(data.requestData.splitRequests);
        }
      } catch (e) {
        const message = (e as Error).message;
        mounted && setError(message ?? e);
      }
      setRequestLoading(false);
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const renderTeacherBreakdown = (type: string, options: any[]) => {
    const inString = ["First", "Second", "Third", "Fourth", "Fifth"];

    return options.map((option: any, index: number) => {
      return {
        title: `${inString[index]} teacher`,
        body: `takes ${formatToString(option.names)} in ${formatToString(
          option.subjectGroup
        )}`,
      };
    });
  };

  return (
    <Modal isOpen={true} onClose={handleClosingModal} trapFocus={true}>
      <ModalOverlay />
      <ModalContent minW={"500px"} py="1rem">
        <ModalCloseButton mt="1rem" />
        <ModalHeader>
          <Heading size="lg" mb="1rem">
            Tutor Arrangement
          </Heading>
        </ModalHeader>
        <ModalBody>
          {requestLoading ? (
            <Box display="flex" justifyContent={"center"} alignItems={"center"}>
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
              />
            </Box>
          ) : (
            <>
              <Stack spacing={[3, 4]} fontSize="sm" isInline mb="1.5rem">
                <Flex
                  width="100%"
                  justifyContent="space-between"
                  direction={["column", "row"]}
                >
                  <Stack mr={[0, 3]} mb={[3, 0]}>
                    <Stack
                      spacing={[0, 0, 3]}
                      isInline
                      flexDirection={["column", "column", "row"]}
                      align={["flex-start", "flex-start", "center"]}
                      mb={2}
                    >
                      <Text fontWeight="semibold" fontSize="md">
                        {splitRequests.length} {teacherOption}
                      </Text>
                    </Stack>
                    {renderTeacherBreakdown(teacherOption, splitRequests).map(
                      (option) => (
                        <Text opacity="0.8">
                          <b>{option.title}</b> - {option.body}
                        </Text>
                      )
                    )}
                  </Stack>
                </Flex>
              </Stack>
            </>
          )}
        </ModalBody>
        <ModalFooter display={"block"}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            w={"full"}
          ></Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
